// reducers/topicReducer.js

const initialState = {
    selectedChatTopic: null,
    selectedForumTopic: null,
};

const topicReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SELECTED_CHAT_TOPIC':
            return {
                ...state,
                selectedChatTopic: action.payload,
            };
        case 'SET_SELECTED_FORUM_TOPIC':
            return {
                ...state,
                selectedForumTopic: action.payload,
            };
        default:
            return state;
    }
};

export default topicReducer;
